import collectionModel from "../models/vendorcollection.model";

import vendorcategoriesModel from "../models/vendorcategories.model";
import vendorcollectionModel from "../models/vendorcollection.model";

const filterCategory = (string, callback) => {
  new Promise((resolve) => {
    setTimeout(async () => {
      // callback(filterColors(inputValue));

      console.log(string);
      if (string == "" || string.length < 3) {
        return null;
      }

      const data = await vendorcategoriesModel.list({ title: string });
      const tempData = data?.data;
      tempData?.map((item) => {
        item.value = item.id;
        item.label = item.title;
        return item;
      });
      console.log(tempData);
      callback(tempData);
    }, 1000);
  });
};
const filterCollection = (string, callback) => {
  new Promise((resolve) => {
    setTimeout(async () => {
      // callback(filterColors(inputValue));

      console.log(string);
      if (string == "" || string.length < 3) {
        return null;
      }

      const data = await vendorcollectionModel.list({ title: string });
      const tempData = data?.data;
      tempData?.map((item) => {
        item.value = item.id;
        item.label = item.title;
        return item;
      });
      console.log(tempData);
      callback(tempData);
    }, 1000);
  });
};
export default {
  filterCategory,
  filterCollection,
};
